export default __webpack_public_path__ + "static/media/send.058400ef.svg";